import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

import ValidatedPws from "../../components/ValidatedInput/ValidatedPws/ValidatedPws";
import ButtonFotter from "../../components/Button/ButtonFotter/ButtonFotter";
import ValidatedInput from "../../components/ValidatedInput/ValidatedInput";
import Button from "../../components/Button/Button";
import Typography from "../../components/Typography/Typography";
import Loader from "../../components/Loader/Loader";
import Switch from "../../components/Switch/Switch";
import LoginImg from "../../assets/loginImage.svg";
import styles from "./Login.module.scss";
import codes from "../../utils/codes";

import { ReactComponent as ArrowLeft } from "../../assets/arrowLeft.svg";
import { loginUser } from "../../utils/services";

const LOGIN_SUCCESS = window.env.REACT_APP_LOGIN_URL;
const RECAPTCHA_KEY = window.env.REACT_APP_GOOGLE_KEY;

const Login = () => {
	const navigate = useNavigate();

	const [username, setUsername] = useState();
	const [usernameError, setUsernameError] = useState();
	const [usernameErrorMjs, setUsernameErrorMjs] = useState();

	const [pws, setPws] = useState();
	const [passwordError, setPasswordError] = useState();
	const [passwordErrorMjs, setPasswordErrorMjs] = useState();

	const [error, setError] = useState(false);
	const [errorMjs, setErrorMjs] = useState(
        "Datos inválidos. Verifica e intenta nuevamente."
    );

	const [keepLoggedIn, setKeepLoggedIn] = useState(false);

	const [token, setToken] = useState(null);
	const [captchaError, setCaptchaError] = useState(false);

	const [loader, setLoader] = useState(false);

	const handleBackClick = () => {
		navigate("/");
	};

	const handleCompleteRegisterClick = () => {
		navigate("/complete-register");
	};

	const handleBtnDisabled = () => {
		if (username && pws && token) return false;
		else return true;
	};

	const handleLogin = () => {
		if (!username) {
			setUsernameError(true);
			setUsernameErrorMjs("Campo inválido");
			return;
		}

		if (!pws) {
			setPasswordError(true);
			setPasswordErrorMjs("Campo inválido");
			return;
		}

		if (!token) {
			setCaptchaError(true);
			return;
		}

		setLoader(true);

		const rData = {
			email: username,
			password: pws,
			captchaToken: token,
			keepLogin: keepLoggedIn,
		};

		loginUser({ formInfo: rData })
			.then(({ message, code }) => {
				if (code === codes.JVB001.code) {
					const loginUrl = LOGIN_SUCCESS.replace(
						"{CODE}",
						message.getAccessToken.access_token
					);

					navigate(loginUrl);
				} else if (
                    code === codes.JVB019.code
                ) {
                    setError(true);
                    setErrorMjs(
                        "Tenemos una intermitencia con servicios externos. Intenta de nuevo en unos minutos."
                    );
                } else {
					setError(true);
					setErrorMjs(
                        "Datos inválidos. Verifica e intenta nuevamente."
                    );
				}
				setLoader(false);
			})
			.catch((e) => setLoader(false));
	};

	return (
		<div className={styles.loginContainer}>
			<div className={styles.loginTitleContainer}>
				<ArrowLeft
					className={styles.loginTitleArrow}
					onClick={handleBackClick}
				></ArrowLeft>

				<div className={styles.loginTitleTxt}>
					<Typography variant="h5">Iniciar Sesión</Typography>
				</div>
			</div>

			<div className={styles.loginCard}>
				<img
					src={LoginImg}
					alt="loging-img"
					className={styles.loginCardImg}
				></img>

				<div className={styles.loginCardContent}>
					<ValidatedInput
						className={styles.loginTextInput}
						label="Correo electrónico o número de identificación"
						placeholder="Escribe aquí tu correo o número de identificación"
						type="text"
						onChange={(v) => {
							setUsername(v);
							setUsernameError(false);
							setPasswordError(false);
							setError(false);
						}}
						error={usernameError}
						setError={setUsernameError}
						errorMessage={usernameErrorMjs}
					></ValidatedInput>

					<ValidatedPws
						className={styles.loginTextInput}
						label="Contraseña"
						placeholder="Escribe tu contraseña"
						onChange={(v) => {
							setPws(v);
							setUsernameError(false);
							setPasswordError(false);
							setError(false);
						}}
						error={passwordError}
						setError={setPasswordError}
						errorMessage={passwordErrorMjs}
					></ValidatedPws>

					<Switch
						className={styles.loginSwitch}
						label="Recordarme"
						onChange={setKeepLoggedIn}
					></Switch>

					<Typography
						color={error ? "red" : "transparent"}
						className={styles.loginErrorMjs}
					>
						{errorMjs}
					</Typography>

					<div className={styles.loginReCaptchaContainer}>
						<div className={styles.loginReCaptcha}>
							<ReCAPTCHA
								sitekey={RECAPTCHA_KEY}
								hl="es"
								onChange={(token) => {
									setCaptchaError(false);
									setToken(token);
								}}
							></ReCAPTCHA>

							{captchaError && (
								<div className={styles.loginReCaptchaBorder}>
									<Typography
										className={styles.loginCaptchaError}
										variant="p2"
										color="red"
									>
										Debe realizar el reCAPTCHA
									</Typography>
								</div>
							)}
						</div>
					</div>

					<div onClick={() => navigate("/forgot-pws")}>
						<Typography className={styles.loginCardForgotPws}>
							¿Olvidaste tu contraseña?
						</Typography>
					</div>
				</div>
			</div>

			<Typography className={styles.loginCompleteRegisterLabel}>
				Si te escribiste en una tienda Juan Valdez,
			</Typography>

			<Button
				className={styles.loginCompleteRegisterBtn}
				onClick={handleCompleteRegisterClick}
			>completa tu registro aquí
			</Button>

			<Typography variant="p4" className={styles.loginRegisterLink}>
				¿Quieres ser Amigo Juan Valdez?{" "}
				<span
					className={styles.loginRegisterLinkSpan}
					onClick={() => navigate("/register/validate-identity")}
				>
					Inscríbete aquí
				</span>
			</Typography>

			<ButtonFotter onClick={handleLogin} disabled={handleBtnDisabled()}>
				Iniciar sesión
			</ButtonFotter>

			{loader && <Loader />}
		</div>
	);
};

export default Login;
